import { axiosInstance } from 'boot/axios.js'
import getCookies from 'boot/cookies.js'

export async function login(ctx, data) {
  try {
    const response = await axiosInstance({
      url: 'auth/token',
      method: 'post',
      data: data
    })
    const cookies = getCookies()

    const options = {
      secure: process.env.PROD,
      expires: parseInt(response.data.tokenLife) / 60 / 60 / 24,
      path: '/'
    }

    cookies.set('auth_token', response.data.token, options)
    cookies.set('auth_token_life', response.data.tokenLife, options)
    cookies.set('auth_token_type', response.data.type, options)

    options.expires = parseInt(response.data.refreshTokenLife) / 60 / 1000
    cookies.set('refresh_token', response.data.refreshToken, options)
    cookies.set('refresh_token_life', response.data.refreshTokenLife, options)

    ctx.commit('isAuthenticated', true)

    axiosInstance.defaults.headers.common['Authorization'] =
      'Bearer ' + response.data.token

    return response
  } catch (e) {
    throw e
  }
}

export async function logout(ctx, data) {
  try {
    const response = await axiosInstance({
      url: 'auth/revoke',
      method: 'post',
      data: data
    })
    const cookies = getCookies()

    cookies.remove('auth_token', { path: '/' })
    cookies.remove('auth_token_life', { path: '/' })
    cookies.remove('auth_token_type', { path: '/' })

    cookies.remove('refresh_token', { path: '/' })
    cookies.remove('refresh_token_life', { path: '/' })

    ctx.commit('isAuthenticated', false)

    delete axiosInstance.defaults.headers.common['Authorization']

    ctx.commit('me', {})

    return response
  } catch (e) {
    throw e
  }
}

export async function recoverPassword(ctx, data) {
  try {
    const response = await axiosInstance({
      url: 'auth/recover-password',
      method: 'post',
      data: data
    })
    ctx.commit('email', data.email)
    return response
  } catch (e) {
    throw e
  }
}

export async function codeVerify(ctx, data) {
  ctx.commit('code', data.verificationCode)
  try {
    const response = await axiosInstance({
      url: '/auth/verification-code/check',
      method: 'post',
      data: data
    })
    return response
  } catch (e) {
    throw e
  }
}

export async function changePassword(ctx, data) {
  try {
    const response = await axiosInstance({
      url: '/auth/reset-password',
      method: 'post',
      data: data
    })
    return response
  } catch (e) {
    throw e
  }
}

export async function me(ctx) {
  try {
    const response = await axiosInstance({
      url: '/auth/user',
      method: 'GET'
    })
    ctx.commit('me', response.data)
    return response
  } catch (e) {
    throw e
  }
}

export function clear(ctx) {
  ctx.commit('isAuthenticated', false)
  const cookies = getCookies()
  cookies.remove('auth_token')
  cookies.remove('auth_token_life')
  cookies.remove('auth_token_type')
  cookies.remove('refresh_token')
  cookies.remove('refresh_token_life')
}
